import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { TabListProps } from './types';

import * as S from './styles';

const SessionsPaymentsTabList: React.FC<TabListProps> = ({
  selectedIndex,
  year,
  month,
}) => {
  let paramYear;
  let paramMonth;

  if (year && month) {
    paramYear = year;
    paramMonth = month;
  } else {
    const currentDate = new Date();

    paramMonth = currentDate.getMonth() + 1;
    paramYear = currentDate.getUTCFullYear();
  }

  return (
    <S.TabMenu selectedIndex={selectedIndex} data-testid="tabMenu">
      <S.TabItem data-testid="tabItem">
        <Link
          data-testid="tabLink"
          to={`/care-provider/session-history?year=${paramYear}&month=${paramMonth}`}
        >
          <FormattedMessage id="CPPLATFORM.SUBTABTITLE.SESSIONS" />
        </Link>
      </S.TabItem>
      <S.TabItem data-testid="tabItem">
        <Link
          data-testid="tabLink"
          to={`/care-provider/payments?year=${paramYear}&month=${paramMonth}`}
        >
          <FormattedMessage id="CPPLATFORM.SUBTABTITLE.PAYMENTS" />
        </Link>
      </S.TabItem>
    </S.TabMenu>
  );
};

export default SessionsPaymentsTabList;
